import { Power0, TweenMax } from 'gsap';

export class ProgressBar extends PIXI.Container {
    public get progress() {
        return this.currentProgress;
    }

    public set progress(progress: number) {
        this.setProgress(progress);
    }

    public progressBar: PIXI.Sprite;
    public progressFill: PIXI.Sprite;
    public tweenDuration = 0.5;
    private currentProgress: number;

    constructor(
        initialProgress: number = 0,
        bg: string = 'mapui/progressbar-top-bg',
        fill: string = 'mapui/progressbar-top-fill'
    ) {
        super();
        this.progressBar = new PIXI.Sprite(PIXI.utils.TextureCache[bg]);
        this.progressFill = new PIXI.Sprite(PIXI.utils.TextureCache[fill]);
        this.progressFill.x = (this.progressBar.width - this.progressFill.width) * 0.5;
        this.progressFill.y = (this.progressBar.height - this.progressFill.height) * 0.5;
        this.addChild(this.progressBar, this.progressFill);
        this.pivot.set(this.progressBar.width / 2, this.progressBar.height / 2);
        this.setProgress(initialProgress, false);
    }

    protected setProgress(progress: number, tween: boolean = true) {
        const clampedProgress = Math.max(0, Math.min(progress, 1));
        if (tween) {
            TweenMax.to(this.progressFill.scale, this.tweenDuration, {
                x: clampedProgress,
                ease: Power0.easeNone,
            });
        } else {
            this.progressFill.scale.x = clampedProgress;
        }
        this.currentProgress = clampedProgress;
    }
}
